import React, { Component } from "react";
import { connect } from "react-redux";
import { addNewExternalApp } from "../redux/actions/appActions";
import { AddExternalAppDialog } from "../dialogs/AddExternalAppDialog";
import { map } from "../utils/map";

export class AddExternalApp extends Component {
  state = {
    title: "",
    packageName: "",
    packageNameNotUnique: false,
    description: "",
    categories: [],
    saveAvaliable: false,
    organizationKey: "",
    globalAccess: false
  };

  componentDidMount() {
    const { currentUser } = this.props;
    const organizationKey = currentUser.organizationRef.id;
    this.setState({ organizationKey });
  }

  onTitleChange = title => this.setState({ title }, this.checkSaveAvaliable);

  onPackageNameChange = packageName =>
    this.setState({ packageName }, this.checkSaveAvaliable);

  onDescriptionChange = description => this.setState({ description });

  onIconFileChange = icon => this.setState({ icon }, this.checkSaveAvaliable);

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  onGlobalAccessChange = globalAccess => this.setState({ globalAccess });

  saveChanges = () => {
    const {
      title,
      packageName,
      description,
      categories,
      icon,
      organizationKey,
      globalAccess
    } = this.state;
    const { onClose, addNewExternalApp } = this.props;
    addNewExternalApp(
      title,
      packageName,
      description,
      categories,
      icon,
      organizationKey,
      globalAccess
    );
    onClose();
  };

  checkSaveAvaliable = () => {
    const { title, packageName, icon, organizationKey } = this.state;
    const { allApps } = this.props;
    
    let packageNameNotUnique = false;
    map(allApps, app => {
      if (packageName === app.packageName && app.organizationRef.id === organizationKey) {
        packageNameNotUnique = true;
      }
    });
    this.setState({ packageNameNotUnique });
    let saveAvaliable = true;
    if (
      title === "" ||
      packageName === "" ||
      !icon ||
      packageNameNotUnique ||
      organizationKey === ""
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onCategoriesChange = categories => {
    this.setState({ categories });
  };

  render() {
    const { allCategories, onClose } = this.props;
    const {
      title,
      packageName,
      packageNameNotUnique,
      icon,
      categories,
      description,
      saveAvaliable,
      organizationKey,
      globalAccess
    } = this.state;
    return (
      <AddExternalAppDialog
        onClose={onClose}
        onSave={this.saveChanges}
        saveAvaliable={saveAvaliable}
        title={title}
        onTitleChange={this.onTitleChange}
        packageName={packageName}
        onPackageNameChange={this.onPackageNameChange}
        packageNameNotUnique={packageNameNotUnique}
        categories={categories}
        onCategoriesChange={this.onCategoriesChange}
        description={description}
        onDescriptionChange={this.onDescriptionChange}
        iconName={icon && icon.name}
        onIconFileChange={this.onIconFileChange}
        allCategories={allCategories}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
        globalAccess={globalAccess}
        onGlobalAccessChange={this.onGlobalAccessChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  apps: state.data.apps,
  allApps: state.data.apps,
  currentUser: state.user.user
});

const mapDispatchToProps = {
  addNewExternalApp
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddExternalApp);
